import React, { FC, ReactElement, useContext } from 'react'
import CLanguageHandler from '../../../../../../NonReact/Languages/LanguageHandler'
import { LanguageContext } from '../../../../../../React/Common/Contexts'
import FormRow from '../../../../../../React/Common/Components/FormRow'
import { ValidationErrors } from '../../../../../../React/Common/Components/ValidationErrors/ValidationErrors'
import { DESCRIPTION_FIELD_NAME, ID_FIELD_NAME } from '../Constants/FieldNames'
import { ClientConfigurationModalLanguage } from '../../../../../../../i18n'
import { OutlinedTextInput } from '../../../../Atoms/Inputs/OutlinedTextInput'

type Props = {
    isEditMode: boolean
    isViewOnly?: boolean
}

export const ClientConfigurationDetails: FC<Props> = ({ isEditMode, isViewOnly }: Props): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler

    return (
        <div className='inner-tab-content'>
            <FormRow>
                <ValidationErrors name={ID_FIELD_NAME}>
                    <OutlinedTextInput
                        labelLeft={language.get(
                            ClientConfigurationModalLanguage.ClientConfigurationModal_Tab_Details_ID
                        )}
                        placeholder={language.get(
                            ClientConfigurationModalLanguage.ClientConfigurationModal_Tab_Details_ID_Placeholder
                        )}
                        inputName={ID_FIELD_NAME}
                        variant='outlined'
                        disabled={isEditMode || isViewOnly}
                    />
                </ValidationErrors>
            </FormRow>
            <FormRow>
                <ValidationErrors name={DESCRIPTION_FIELD_NAME}>
                    <OutlinedTextInput
                        labelLeft={language.get(
                            ClientConfigurationModalLanguage.ClientConfigurationModal_Tab_Details_Description
                        )}
                        variant='outlined'
                        inputName={DESCRIPTION_FIELD_NAME}
                        disabled={isViewOnly}
                        rules={{
                            required: language.get(
                                ClientConfigurationModalLanguage.ClientConfigurationModal_Tab_Details_Description_Required
                            )
                        }}
                    />
                </ValidationErrors>
            </FormRow>
        </div>
    )
}
